import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import LocaleUtils from 'react-day-picker/moment';
import moment from 'moment';
import 'moment/locale/cs';
import 'react-day-picker/lib/style.css';

import ErrorScreen from '../../common/ErrorScreen/ErrorScreen';
import { StyledCalendar } from './styles/StyledCalendar';
import Legend from './Legend';


export const COMMON_DATE_FORMAT = 'DD.MM.YYYY';
const DAY_TYPES = [
  'free',
  'holiday',
  'occupied',
  'blocked',
  'notAvailable'
];


class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDay: null
    };


    this.handleDayClick = this.handleDayClick.bind(this);

    this.modifiers = DAY_TYPES.reduce((result, type) => {
      result[type] = (day) => {
        const { dateToDayMap } = this.props;

        const date = moment(day).format(COMMON_DATE_FORMAT);



        if (dateToDayMap[date]) {
          return type === dateToDayMap[date].type;
        }
        return false;
      }
      return result;
    }, {});
  }

  componentDidMount() {
    const n = ReactDOM.findDOMNode(this);
    this.scroll = n.offsetTop + n.clientHeight;
  }


  handleDayClick(day) {
    const date = moment(day).format(COMMON_DATE_FORMAT);
    const { dateToDayMap, handleOnClickDay } = this.props;
    const dayObject = dateToDayMap[date];

    // Ignore day click when day is out of days range
    if (!dayObject) {
      return
    }

    if (dayObject.type === DAY_TYPES[0]) {
      setTimeout(() => { 
        window.scrollTo({
          top: this.scroll,
          left: 0,
          behavior: 'smooth'
        });
      }, 200);
      handleOnClickDay(dayObject.id, day);
    }
  }

  render() {
    const { days, selectedDate, handleMonthChange } = this.props;
    let error = false;

    if (days.length < 1) {
      error = true;
    }

    if (error) {
      return (
        <StyledCalendar>
          <div className="calendar-wrapper-error">
            <ErrorScreen
              title="Nejsou dostupné žádné dny pro tuto službu."
            />
          </div>
        </StyledCalendar>
      );
    }

    const firstDay = moment(days[0].date);
    const lastDay = moment(days[days.length - 1].date);

    const disabledRange = {
      before: firstDay.toDate(),
      after: lastDay.toDate()
    };

    return (
      <StyledCalendar>
        <DayPicker
          localeUtils={LocaleUtils}
          locale="cs"
          disabledDays={disabledRange}
          onDayClick={this.handleDayClick}
          onMonthChange={handleMonthChange}
          selectedDays={selectedDate}
          fromMonth={firstDay.toDate()}
          toMonth={lastDay.toDate()}
          modifiers={this.modifiers}
        />
        <Legend />
      </StyledCalendar>
    );
  }
}


Calendar.propTypes = {
  days: PropTypes.array.isRequired,
  dateToDayMap: PropTypes.object.isRequired,
  handleOnClickDay: PropTypes.func.isRequired,
  selectedDate: PropTypes.any,
  handleMonthChange: PropTypes.func.isRequired,
};


export default Calendar;


// WEBPACK FOOTER //
// ./src/components/IntervalsContent/Calendar.js